import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import apiService, { getImageUrl } from '../../services/api';

// Fallback gallery images if API fails
const fallbackGallery = [
  {
    title: 'Gallery Post 1',
    image: '/assets/img/widget/gallery_1_1.jpg',
    post_url: 'https://www.instagram.com/',
    platform: 'instagram'
  },
  {
    title: 'Gallery Post 2', 
    image: '/assets/img/widget/gallery_1_2.jpg',
    post_url: 'https://www.instagram.com/',
    platform: 'instagram'
  },
  {
    title: 'Gallery Post 3',
    image: '/assets/img/widget/gallery_1_3.jpg',
    post_url: 'https://www.instagram.com/',
    platform: 'instagram'
  },
  {
    title: 'Gallery Post 4',
    image: '/assets/img/widget/gallery_1_4.jpg',
    post_url: 'https://www.instagram.com/',
    platform: 'instagram'
  },
  {
    title: 'Gallery Post 5',
    image: '/assets/img/widget/gallery_1_5.jpg',
    post_url: 'https://www.instagram.com/',
    platform: 'instagram'
  },
  {
    title: 'Gallery Post 6',
    image: '/assets/img/widget/gallery_1_6.jpg',
    post_url: 'https://www.instagram.com/',
    platform: 'instagram'
  }
];

function SocialMediaGallery({ 
  title = "Instagram Post",
  maxItems = 6,
  showFeaturedOnly = true,
  className = "sidebar-gallery" 
}) {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSocialPosts = async () => {
      try {
        const response = showFeaturedOnly 
          ? await apiService.getFeaturedSocialMediaPosts()
          : await apiService.getSocialMediaPosts();
          
        if (response && response.results && response.results.length > 0) {
          // Limit to maxItems
          setPosts(response.results.slice(0, maxItems));
        } else {
          // Use fallback data if no posts from API
          setPosts(fallbackGallery.slice(0, maxItems));
        }
      } catch (error) {
        console.error('Error fetching social media posts:', error);
        // Use fallback data on error
        setPosts(fallbackGallery.slice(0, maxItems));
      } finally {
        setLoading(false);
      }
    };

    fetchSocialPosts();
  }, [maxItems, showFeaturedOnly]);

  if (loading) {
    return (
      <div className="widget footer-widget">
        <h3 className="widget_title">{title}</h3>
        <div className="text-center">
          <div className="spinner-border spinner-border-sm text-primary" role="status">
            <span className="visually-hidden">Loading gallery...</span>
          </div>
        </div>
      </div>
    );
  }

  const getPlatformIcon = (platform) => {
    const iconMap = {
      facebook: 'fab fa-facebook-f',
      instagram: 'fab fa-instagram',
      twitter: 'fab fa-twitter', 
      youtube: 'fab fa-youtube',
      linkedin: 'fab fa-linkedin-in',
      pinterest: 'fab fa-pinterest-p',
      tiktok: 'fab fa-tiktok'
    };
    return iconMap[platform] || 'fab fa-instagram';
  };

  return (
    <div className="widget footer-widget">
      <h3 className="widget_title">{title}</h3>
      <div className={className}>
        {posts.map((post, index) => {
          // Handle both API structure and fallback structure
          const postImage = getImageUrl(post.image) || post.image || `/assets/img/widget/gallery_1_${(index % 6) + 1}.jpg`;
          const postUrl = post.post_url || 'https://www.instagram.com/';
          const postTitle = post.title || `Post ${index + 1}`;
          const platform = post.platform || 'instagram';
          const platformIcon = getPlatformIcon(platform);
          const isExternalLink = postUrl && postUrl !== '#' && postUrl.startsWith('http');
          
          return (
            <div key={post.id || index} className="gallery-thumb">
              <img
                src={postImage}
                alt={postTitle}
                loading="lazy"
              />
              {isExternalLink ? (
                <a
                  href={postUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="gallery-btn"
                  title={`View ${postTitle} on ${platform}`}
                  aria-label={`View ${postTitle} on ${platform}`}
                >
                  <i className={platformIcon} />
                </a>
              ) : (
                <Link
                  to={postUrl === '#' ? '#' : postUrl}
                  className="gallery-btn"
                  title={`View ${postTitle}`}
                  aria-label={`View ${postTitle}`}
                >
                  <i className={platformIcon} />
                </Link>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default SocialMediaGallery;
